import { FC } from 'react'
import { CreditCardPanePreset } from 'components/features/creditCard/creditCardPanes/CreditCardPanePreset'
import Flex from 'components/atoms/Flex/Flex'
import { CC_SUPPORT_PHONE_NUMBER } from 'components/features/creditCard/creditCardStore/constants'

const ChangePinPane: FC<{}> = () => {
  return (
    <CreditCardPanePreset title='Set/Change PIN' cardLayout>
      <Flex theme='info' padding='responsive'>
        For changes regarding account security, please contact customer support
        at <a href={ `tel:${ CC_SUPPORT_PHONE_NUMBER }` }>{ CC_SUPPORT_PHONE_NUMBER }</a>
      </Flex>
      <br />
    </CreditCardPanePreset>
  )
}

export default ChangePinPane
